<template>
  <div v-if="!ShowCommunityPage && !ShowStorytellingPage" class="search-results">
    <div class="title-section">
      <h2>Experience Metrics</h2>
      <h3>Analisi per <span class="company-name">{{ sessionstore.company_name }}</span></h3>
    </div>
    <div class="score-section">
      <div class="score-info">
        <p class="score-title">Abbiamo calcolato il tuo score</p>
        <div class="score-bar">
          <div class="score-fill" :style="{ width: sessionstore.experienceScore * 10 + '%' }"></div>
        </div>
        <div class="score-value">{{ sessionstore.experienceScore * 10 }} / 100</div>
      </div>
    </div>
    <div class="score-feedback">
      <div v-if="sessionstore.experienceError" class="feedback-text">BrandRatio sta lavorando per migliorare il calcolo
        dello score di experience. Per favore, riprova più tardi.</div>
      <div v-else-if="sessionstore.experienceScore >= 0 && sessionstore.experienceScore <= 5" class="feedback-text">{{
        TextPlaceholders[0] }}</div>
      <div v-else-if="sessionstore.experienceScore >= 6 && sessionstore.experienceScore <= 8" class="feedback-text">{{
        TextPlaceholders[1] }}</div>
      <div v-else class="feedback-text">{{ TextPlaceholders[2] }}</div>
    </div>
  </div>
</template>

<script>
import { useSessionStore } from '@/stores/sessionStore';
import { onMounted, onUnmounted } from 'vue';
import { useToast } from 'vue-toastification';

export default {
  setup() {
    const sessionstore = useSessionStore();
    const toast = useToast();


    onMounted(() => {
      if (sessionstore.experienceError) {
        toast.error("Errore nel calcolo dello score di experience: " + sessionstore.experienceError);
      }
    });

    onUnmounted(() => {
      sessionstore.experienceError = '';
    });

    return {
      sessionstore
    };
  },
  name: "ExperienceMetrics",
  components: {
  },

  data() {
    return {
      ShowCommunityPage: false,
      ShowStorytellingPage: false,
      TextPlaceholders: [
        "L'azienda sembra non prestare molta attenzione all'esperienza del cliente oltre al prodotto stesso. Il servizio clienti è carente, la vendita online non è ottimizzata e manca la possibilità di personalizzazione. Questi elementi fondamentali contribuiscono a una brand experience negativa, che può danneggiare la percezione complessiva dell'azienda da parte dei clienti e ridurre la fedeltà del cliente",
        "L'azienda sta lavorando per migliorare l'esperienza del cliente, ma ci sono ancora aree in cui è necessario fare progressi. Il servizio clienti può essere migliorato, la vendita online è funzionale ma non ottimizzata, e la personalizzazione potrebbe essere più marcata. Anche se ci sono miglioramenti rispetto al voto precedente, l'azienda deve concentrarsi su un'esperienza più completa e soddisfacente per i clienti",
        "L'azienda offre un'esperienza del cliente eccezionale in tutti gli aspetti. Il servizio clienti è rapido ed efficiente, la vendita online è intuitiva e piacevole, e c'è un alto livello di personalizzazione disponibile per i clienti. Questi elementi contribuiscono a una brand experience straordinaria, che non solo soddisfa i clienti ma li fidelizza e promuove una reputazione positiva dell'azienda. Congratulazioni all'azienda per il suo impegno nell'offrire un'esperienza del cliente di alta qualità."
      ]
    };
  },
  methods: {
    showPage() {
      this.ShowCommunityPage = true;
    },
    showPreviousPage() {
      this.ShowCommunityPage = false;
      this.ShowStorytellingPage = true;
    },
  }
};
</script>

<style lang="scss" scoped>
.search-results {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  min-height: 100vh;
  padding: 4rem 2rem;
}

.title-section {
  width: 100%;
  max-width: 1200px;
  text-align: left;
  margin-bottom: 3rem;

  h2 {
    font-size: 2.5rem;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1.8rem;
    font-weight: 500;
    color: #1a1a1a;
  }

  .company-name {
    color: #2e4eed;
  }
}

.score-section {
  width: 100%;
  max-width: 1200px;
  margin-bottom: 3rem;
}

.score-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.score-title {
  font-size: 1.8rem;
  font-weight: 500;
  color: #1a1a1a;
}

.score-bar {
  width: 100%;
  height: 2rem;
  background-color: rgba(46, 78, 237, 0.1);
  border: 2px solid #2e4eed;
  overflow: hidden;
}

.score-fill {
  height: 100%;
  background-color: #2e4eed;
  transition: width 1s ease-in-out;
}

.score-value {
  font-size: 4rem;
  font-weight: 600;
  color: #2e4eed;
}

.score-feedback {
  width: 100%;
  max-width: 1200px;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.95);
  border: 2px solid #2e4eed;
  margin-top: 2rem;
}

.feedback-text {
  font-size: 1.8rem;
  font-weight: 500;
  color: #1a1a1a;
  line-height: 1.5;
  text-align: left;
}

@media (max-width: 768px) {
  .search-results {
    padding: 2rem 1rem;
  }

  .title-section {
    h2 {
      font-size: 2rem;
    }

    h3 {
      font-size: 1.5rem;
    }
  }

  .score-title {
    font-size: 1.5rem;
  }

  .score-value {
    font-size: 3rem;
  }

  .feedback-text {
    font-size: 1.5rem;
  }
}
</style>